module.exports = "/_next/static/images/icon-find-8f692a415f2a31adce1faf0ee0f3435a.png";